import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MicrosoftTeamsCallQueue } from '../../../shared/models/generated/ziroModels';

@Injectable({ providedIn: 'root' })
export class MicrosoftCallQueueSearchResource {
  private http = inject(HttpClient);

  search(tenantId: string, query: string): Observable<MicrosoftTeamsCallQueue[]> {
    return this.http.get<MicrosoftTeamsCallQueue[]>(
      `/services/microsoft/call-queue-management/tenants/${tenantId}/call-queues/search?name=${encodeURIComponent(query)}`,
    );
  }
}
